import { createFileRoute } from "@tanstack/react-router";
import OrderTracking from "../../screens/OrderTracking";

export const Route = createFileRoute("/c/ordertracking")({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>): { orderId?: string } => ({
    orderId: typeof search.orderId === "string" ? search.orderId : undefined,
  }),
});

function RouteComponent() {
  return <div><OrderTracking /></div>;
}